export * from "./getCompOnlyType";
